const UNIVERSAL_LINK_ORIGIN = 'https://oneword.economicusgame.com'
const ROOM_PATH = /^\/(\d{4})\/?$/

const getRoomIdFromUniversalLink = (value: string) => {
  try {
    const url = new URL(value)
    if (url.origin !== UNIVERSAL_LINK_ORIGIN) return undefined

    return ROOM_PATH.exec(url.pathname)?.[1]
  } catch {
    return undefined
  }
}

export { getRoomIdFromUniversalLink, UNIVERSAL_LINK_ORIGIN }
